import { render, staticRenderFns } from "./ReserveConfirm.vue?vue&type=template&id=1125f7b1&scoped=true"
import script from "./ReserveConfirm.vue?vue&type=script&lang=js"
export * from "./ReserveConfirm.vue?vue&type=script&lang=js"
import style0 from "./ReserveConfirm.vue?vue&type=style&index=0&id=1125f7b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125f7b1",
  null
  
)

export default component.exports